/**
 * Generate a uniqid
 *
 * @return {string}
 */
export function uniqid(): string {
  const sec = (Date.now() * 1000) + (Math.random() * 1000);
  const id = sec.toString(16).replace(/\./g, '').padEnd(14, '0');

  return id + Math.trunc(Math.random() * 100000000);
}

/**
 * Format a date into  01.10.2025
 *
 * @return {string}
 */

export function formatDate(date: Date | number): string {
  try {
    const inputDate: Date = typeof date === 'number' ? new Date(date) : date;
    const day = String(inputDate.getDate()).padStart(2, '0');
    const month = String(inputDate.getMonth() + 1).padStart(2, '0');
    const year = inputDate.getFullYear();
    return `${day}.${month}.${year}`;

  } catch (e: unknown) {
    console.log(`Error while formating date: ${date}`);
  }

  return '';
}

export const slugify = (str: string): string =>
  str.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_]+/g, '-');